export abstract class CustomerException extends Error {
}
